if (!customElements.get('card-variant-form')) {
  customElements.define(
    'card-variant-form',
    class CardVariantForm extends HTMLElement {
      constructor() {
        super();

        this.idInput = this.querySelector('.card-variant-form__id-input');
        this.quantityInput = this.querySelector('.quantity__input');
        this.selects = Array.from(this.querySelectorAll('.card-variant-picker__select'));

        const variantsScript = this.querySelector('[data-card-variants]');
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

        this.selects.forEach((select) => {
          select.addEventListener('change', this.onOptionChange.bind(this));
        });

        this.cartUpdateUnsubscriber = undefined;
      }

      connectedCallback() {
        this.updateForSelectedVariant();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      get productForm() {
        return this.querySelector('product-form');
      }

      /* ---------- variant resolution ---------- */

      getSelectedOptions() {
        return this.selects
          .slice()
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((select) => select.value);
      }

      findMatchingVariant() {
        if (!this.selects.length) {
          // Product has only the default variant.
          return this.variants[0] || null;
        }

        const selected = this.getSelectedOptions();

        return (
          this.variants.find((variant) => {
            const options = variant.options || [];
            return selected.every((value, index) => options[index] === value);
          }) || null
        );
      }

      /* ---------- availability (mirrors snippets/buy-buttons.liquid) ---------- */

      isVariantSoldOut(variant) {
        if (!variant) return true;
        if (variant.available === false) return true;

        const checkAgainstInventory =
          variant.inventory_management === 'shopify' && variant.inventory_policy !== 'continue';

        if (
          checkAgainstInventory &&
          variant.quantity_rule &&
          typeof variant.inventory_quantity === 'number' &&
          variant.quantity_rule.min > variant.inventory_quantity
        ) {
          return true;
        }

        return false;
      }


    updatePrice(variant) {
    const priceElement = this.querySelector('[data-card-price]');

    if (!priceElement || !variant) return;

    priceElement.textContent = (variant.price / 100).toLocaleString(
        Shopify.locale || 'en',
        {
        style: 'currency',
        currency: Shopify.currency.active
        }
    );
    }

      /* --------- UI updates ---------- */

      onOptionChange() {
        this.updateForSelectedVariant();
      }

      updateForSelectedVariant() {
        const variant = this.findMatchingVariant();
        this.currentVariant = variant;
        const soldOut = this.isVariantSoldOut(variant);

        if (this.idInput) {
          this.idInput.value = variant ? variant.id : '';
        }
        this.updatePrice(variant);
        this.updateQuantityBoundaries(variant);
        this.updateSubmitButton(variant, soldOut);

        this.classList.toggle('card-variant-form--sold-out', !variant || soldOut);
      }

      updateSubmitButton(variant, soldOut) {
        const productForm = this.productForm;

        // Reuse the product page's own toggleSubmitButton() so the card behaves
        // exactly like assets/product-info.js does on the product page.
        if (productForm && typeof productForm.toggleSubmitButton === 'function') {
          if (!variant) {
            productForm.toggleSubmitButton(true, window.variantStrings?.unavailable || this.dataset.unavailableText);
          } else if (soldOut) {
            productForm.toggleSubmitButton(true, window.variantStrings?.soldOut || this.dataset.soldOutText);
          } else {
            productForm.toggleSubmitButton(false);
          }
          return;
        }

        // Fallback in case <product-form> hasn't upgraded for some reason.
        const submitButton = this.querySelector('.card-variant-form__submit');
        const submitText = this.querySelector('.card-variant-form__submit-text');
        if (submitButton) submitButton.disabled = !variant || soldOut;
        if (submitText) {
          submitText.textContent = !variant
            ? this.dataset.unavailableText
            : soldOut
            ? this.dataset.soldOutText
            : this.dataset.addToCartText;
        }
      }

      updateQuantityBoundaries(variant) {
        if (!this.quantityInput || !variant || !variant.quantity_rule) return;

        const rule = variant.quantity_rule;
        this.quantityInput.min = rule.min || 1;
        this.quantityInput.step = rule.increment || 1;

        if (rule.max) {
          this.quantityInput.max = rule.max;
        } else {
          this.quantityInput.removeAttribute('max');
        }

        if (Number(this.quantityInput.value) < Number(this.quantityInput.min)) {
          this.quantityInput.value = this.quantityInput.min;
        }

        // Let the existing <quantity-input> web component (assets/global.js)
        // re-validate its +/- buttons against the new min/max.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        }
      }

      /* ---------- live stock refresh after add-to-cart ---------- */

      onCartUpdate(event) {
        const variantId = event?.data?.productVariantId;
        if (!this.currentVariant || String(variantId) !== String(this.currentVariant.id)) return;
        this.refreshStock();
      }

      refreshStock() {
        const url = this.dataset.productUrl;
        if (!url) return;

        fetch(`${url}.js`)
          .then((response) => response.json())
          .then((product) => {
            if (!product || !product.variants) return;
            this.variants = product.variants;
            this.updateForSelectedVariant();
          })
          .catch((error) => console.error(error));
      }
    }
  );
}